// src/marketing/editorial/ReadingProgress.tsx
import { JSX, useEffect, useRef } from 'react'

export function ReadingProgress(): JSX.Element {
  const barRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function handleScroll(): void {
      const scrollTop = window.scrollY
      const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight
      const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0
      if (barRef.current) {
        barRef.current.style.width = `${progress}%`
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div
      ref={barRef}
      className="reading-progress"
      data-testid="reading-progress"
    />
  )
}
